function getTarget(event: Event): HTMLElement | null {
	let customEventTarget = (event.target ?? event.srcElement ?? document) as HTMLElement;

	while (customEventTarget != null && customEventTarget.nodeType === Node.TEXT_NODE) {
		customEventTarget = customEventTarget.parentNode as HTMLElement;
	}

	return customEventTarget;
}

export default function eventMatches(event: Event, selector: string): HTMLElement | undefined {
	const root = event.currentTarget as HTMLElement
	const body = document.body;
	let target = getTarget(event);

	while (target != null && target != root) {
		if (target.matches(selector) && (root == body || root.contains(target))) {
			return target;
		}

		target = target.parentElement;
	}

	return undefined;
}
